import { sendTrackingEvent } from 'tracking/utils';
import { parseLabel } from './parseLabel';

export const trackHeaderNavClick = (label: string) => {
  const category = parseLabel(label);

  sendTrackingEvent('HEADER_TAP', { header_category: category });
};
